<template>
  <div class="sponsors container">
    <div class="slider-header">
      <div class="title-invisible">
        <h4 class="title">Sponsors</h4>
      </div>
    </div>

    <div v-if="mobile" class="mobile">
      <swiper :options="sponsorsOptions" ref="mySwiper">
        <swiper-slide v-for="item in sponsors" :key="item.title">
          <div>
            <img :src="item.logoUrl" :alt="item.title" />
            <a :href="item.url" target="_blank"></a>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination sponsors-slider" slot="pagination"></div>
    </div>

    <div v-else class="sponsors-list">
      <div v-for="item in sponsors" :key="item.title" class="sponsor-item">
        <img :src="item.logoUrl" :alt="item.title" />
        <a :href="item.url" target="_blank"></a>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Swiper_button from "@/components/shared/Swiper_button";

const url = process.env.VUE_APP_URL;

export default {
  data() {
    return {
      sponsorsOptions: {
        slidesToShow: 1,
        //loop: true,
        dots: true,
        arrows: false,
        speed: 1500,
        easing: "cubic-bezier(.6,0,.22,1)",
        pagination: {
          el: ".sponsors-slider",
          dynamicBullets: true,
          dynamicMainBullets: 3,
          clickable: true,
        },
      },
      sponsorsOptionsDesctop: {
        title: {
          nextEl: "nextSponsor blue",
          prevEl: "prevSponsor blue",
          pagination: "sponsors-decktop-slider",
          title: "Sponsors",
        },
        options: {
          speed: 800,
          slidesPerView: 5,
          spaceBetween: 0,
          direction: "horizontal",
          //loop: true,
          dynamicBullets: true,
          arrows: false,
          pagination: {
            el: ".swiper-pagination.sponsors-decktop-slider",
            dynamicBullets: true,
            dynamicMainBullets: 5,
            clickable: true,
          },
          navigation: {
            nextEl: ".nextSponsor",
            prevEl: ".prevSponsor",
          },
          breakpoints: {},
        },
      },
    };
  },
  computed: {
    sponsors() {
      return this.$store.getters.sponsors;
    },
    mobile() {
      return this.$store.state.mobile;
    },
    sponsorsLength() {
      return this.$store.getters.sponsors.length;
    },
  },
  methods: {
    setSponsors() {
      this.axios
        .get(url + "/sponsors", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          return this.$store.dispatch("setSponsors", payload);
        });
    },
  },
  mounted() {
    this.setSponsors();
  },
  components: {
    swiper,
    swiperSlide,
    "app-swiper-btn": Swiper_button,
  },
};
</script>
<style lang="scss" scoped>
.sponsors {
  position: relative;
  padding: 9rem 0 8.5rem;
  @media only screen and (max-width: 992px) {
    padding: 6rem 0;
  }
  @media only screen and (max-width: 768px) {
    padding-bottom: 9rem;
  }
  .slider-header {
    margin-bottom: 2.4rem;
  }
  .title {
    margin-bottom: 0;
  }
  & > div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    div.sponsor-item {
      position: relative;
      padding: 0 1.5rem;
      margin: 0;
      width: calc(100% / 8);
      img {
        width: auto;
        max-height: 10rem;
        min-width: 10rem;
      }
      @media only screen and (max-width: 992px) {
        width: 15%;
        img {
          max-width: 100%;
          width: 20rem;
        }
      }
      @media only screen and (max-width: 768px) {
        width: 100%;
        height: 20rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin: 0 auto;
        }
      }
      a {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }

    &.sponsors-list {
      -webkit-box-pack: space-evenly;
      -ms-flex-pack: space-evenly;
      justify-content: space-evenly;
    }
  }
}
.mobile,
.slider-display {
  position: relative;
}
.swiper-pagination {
  margin-bottom: 0 !important;
  @media only screen and (max-width: 768px) {
    bottom: -3rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
.swiper-slide {
  & > div {
    height: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    a {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      cursor: pointer;
    }
    img {
      max-width: 19rem;
    }
  }
}

.sponsors > div div.swiper-slide:not(.swiper-pagination) {
  & > div {
    width: initial;
  }
  @media only screen and (max-width: 992px) {
    width: initial;
  }
}
.slider-navigation {
  width: calc(117rem / 3);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  @media only screen and (max-width: 768px) {
    display: none;
  }
}
.sponsors-decktop-slider {
  height: 3px;
}
</style>